export class CrossSiteUserNotificationsData {
    public formId: number;
    public formName: string;
    public siteId: number;
    public siteName: string;
    public folderId: number;
    public modifiedDate: Date;
    public modifiedBy: string;
    public workflowState: string;

    public isSuscribedToWorkflowChanges: boolean;
}
export class CrossSiteUserNotificationsResults {
    public results: CrossSiteUserNotificationsData[] = [];

    public resultsAsPlainObjects: object[] = []; // results translated into plain JS objects needed by Kendo Grid by service code

    public total: number = 5000;
}
